import React from 'react';

export const BETA_TAG = 'Beta';

const BetaTag = () => {
    return  <sup>{BETA_TAG}</sup>;
};

export default BetaTag;